module.exports = __webpack_public_path__ + "77e28c59b7a24ca9a1cdf625be8270c4.png";